<template>
    <div>
        <sau-service-status :service="service"></sau-service-status>
    </div>
</template>

<script>
import PowerCheck from './_PowerCheck';

export default {
    props: ['service'],
    components: {
        'sau-cloud-power-check': PowerCheck,
    },
}
</script>
